function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50.213%",
  y1: ".078%",
  x2: "50.213%",
  y2: "100.078%",
  id: "gas-pgn_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F69321",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F27D17",
  offset: "7%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ED680D",
  offset: "17%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EA5906",
  offset: "28%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E95001",
  offset: "40%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E84D00",
  offset: "59%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C43C00",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.567 39.733H7.464a5.448 5.448 0 01-5.446-5.448V15.316a5.446 5.446 0 015.444-5.45h17.106a5.45 5.45 0 015.45 5.45v18.97a5.45 5.45 0 01-5.45 5.447",
  fill: "url(#gas-pgn_svg__a)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.883 39.733H28.15v3.734H3.883z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.803 43.467H5.228a1.346 1.346 0 01-1.345-1.347v-1.044c0-.741.601-1.343 1.345-1.343h21.575c.743 0 1.347.602 1.347 1.343v1.044a1.35 1.35 0 01-1.347 1.348",
  fill: "#F58220",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.148 28.537H31.88v3.73H.148z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.535 32.267H1.496a1.345 1.345 0 01-1.348-1.345v-1.044c0-.741.605-1.341 1.348-1.341h29.037c.743 0 1.348.601 1.348 1.343v1.044c0 .743-.605 1.344-1.348 1.344",
  fill: "#F58220",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.148 17.335H31.88v3.733H.148z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.535 21.068H1.496A1.345 1.345 0 01.148 19.72v-1.04c0-.743.605-1.345 1.348-1.345h29.037c.743 0 1.348.602 1.348 1.345v1.04c0 .745-.605 1.348-1.348 1.348M7.615 10.6h3.733V3.135H7.615V10.6zm13.068 0h3.733V3.135h-3.733V10.6z",
  fill: "#F58220",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.713 4.066H6.315a1.345 1.345 0 01-1.343-1.345V1.678c0-.742.601-1.345 1.343-1.345h19.398a1.35 1.35 0 011.348 1.345V2.72c0 .744-.605 1.345-1.348 1.345",
  fill: "#F58220",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.015 6.066v3.336m1.666-3.336h-3.334",
  stroke: "#F58220",
  strokeWidth: 1.728,
  strokeLinecap: "round"
}));

function SvgGasPgn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgGasPgn;